@if (!isFullscreen()) {
	<df-nav-bar></df-nav-bar>
}
<div class="position-relative" [class.df-fullscreen-content]="isFullscreen()">
	<div [class]="isFullscreen() ? 'container-fluid' : 'container my-3'">
		@switch (contentState()) {
			@case ('failed') {
				<df-load-failure variant="failed" />
			}
			@case ('signed-out') {
				<df-load-failure variant="signed-out" />
			}
			@default {
				<router-outlet />
			}
		}
	</div>
</div>

<button
	class="df-fullscreen-btn btn btn-dark"
	(click)="toggleFullscreen()"
	[title]="isFullscreen() ? 'Exit fullscreen' : 'Enter fullscreen'"
>
	<i [class]="isFullscreen() ? 'bi-fullscreen-exit' : 'bi-fullscreen'"></i>
</button>

<df-settings-drawer />
